export enum LocationTypes {
  Azure = 'azure'
}